import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../../hooks/redux';
import { SetNewPasswordForm } from '../../../../forms/SetNewPasswordFrom';
import { iptvApi } from '../../../../../services/apiServices/user/iptv';
import { ModalVariants, InputRegexPattern } from '../../../../../models/Common';
import { useCustomSnackbar } from '../../../../../hooks/useCustomEnqueueSnackbar';
import { modalSlice } from '../../../../../store/reducers/ModalSlice';

interface EditBrizTvPasswordProps {
  accountId: string | number;
  handleClose: () => void;
}

export const EditBrizTvPassword: FC<EditBrizTvPasswordProps> = ({ accountId, handleClose }) => {
  const { t } = useTranslation();
  const { customEnqueueSnackbar } = useCustomSnackbar();
  const [editBrizTv, { isLoading }] = iptvApi.useEditBrizTvMutation();
  const dispatch = useAppDispatch();
  const { openModal } = modalSlice.actions;

  const handleEditPassword = async ({ password, currentPassword }: { password: string; currentPassword: string }) => {
    return editBrizTv({ password, accountId, currentPassword })
      .unwrap()
      .then(() => {
        customEnqueueSnackbar(t('snackbar.passwordBrizTvSuccessfullyChanged'), 'success');
        handleClose();
      });
  };

  const handleForgotPassword = () => {
    dispatch(openModal({ modalVariants: ModalVariants.LogOut }));
  };

  return (
    <div className="modals">
      <div className="modals__header">
        <article className="modals__header__title">{t('modals.changePassword')}</article>
      </div>
      <SetNewPasswordForm
        description={false}
        submitNewPassword={handleEditPassword}
        buttonText={t('buttons.saveChanges')}
        helperText={t('input.numberOfCharactersInLatinNumbersOneNumberLetterRequired', { from: 6, to: 16 })}
        pattern={InputRegexPattern.OneNumberOneLetter}
        isLoading={isLoading}
        handleForgotPassword={handleForgotPassword}
      />
    </div>
  );
};
